import styled from 'styled-components';

export const MapDeckStyles = styled.div`
  position: relative;
  width: 100%;

  #map-wrap {
    position: relative;
    width: calc(100% - 2px);
    max-width: 840px;
    margin: 0 auto;
    height: 600px;
    border: 1px solid #ebeaea;
  }

  @media (max-width: 600px) {
    #map-wrap {
      height: 450px;
    }
  }

  .mapContainer {
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  .fade-in {
    opacity: 1;
    transition: opacity 0.6s ease-in-out;
  }
  .control-panel {
    position: relative;
    width: 100%;
    min-height: 70px;
    display: flex;
  }

  /* suggested styles for tooltip */
  /* Example if you use a global CSS or inside styled-components block */
  /* Container ignores events; inner card handles them */
  .click-tooltip {
    position: absolute;
    transform: translateX(-50%);
    z-index: 5;
    pointer-events: none;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 8px;
  }

  .click-tooltip .tt-inner {
    pointer-events: auto;
    // background: #fff;
    background: var(--accentA);
    color: #111;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    padding: 10px 12px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
    width: 64vw;
    max-width: 320px; /* tweak as needed */
  }

  .tt-header {
    margin-bottom: 6px;
  }
  .tt-row {
    font-size: 13px;
    line-height: 1.35;
    margin: 4px 0;
  }
  .tt-row.large {
    font-size: 16px;
    font-weight: 600;
  }
  .tt-row.small {
    font-size: 12px;
    color: #666;
  }

  /* Scrollable content area capped at 200px */
  .tt-body {
    max-height: 250px;
    overflow-y: auto;
    overscroll-behavior: contain; /* stop scroll chaining */
    -webkit-overflow-scrolling: touch; /* smooth iOS scroll */
    padding-right: 6px; /* room for scrollbar */
  }

  @media (max-width: 600px) {
    .tt-body {
      max-height: 200px;
    }
  }

  .tt-body .chip {
    background: var(--accentA);
    border: 1px solid var(--accent);
  }

  /* Optional: nicer thin scrollbars */
  .tt-body {
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.25) transparent;
  }
  .tt-body::-webkit-scrollbar {
    width: 8px;
  }
  .tt-body::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.25);
    border-radius: 4px;
  }
  .tt-body::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Close button */
  .tt-close {
    margin-top: 8px;
    font-size: 12px;
    background: #f5f5f5;
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 4px 8px;
    cursor: pointer;
  }
`;
